import React from 'react'
import { TeamScoresCol } from './weekStyles'
import { createUrl } from '../../../../Routing/urls'
import type { EventGQL, TeamGQL } from '../../../../Api'
import { getTeamIc, getTeamRecord } from '../../../../Utils'
import { Lk } from '../../../../Components/Links/Lk'

type TeamParams = {
  team: TeamGQL
  event: EventGQL
  score: number
}

export const Team: React.FC<React.PropsWithChildren<TeamParams>> = ({
  team,
  event,
  score,
}) => {
  let teamName = team?.fullName ? `${team?.location || ''} ${team.fullName}` : 'TBA'

  return (
    <Lk link={team?.fullName ? createUrl('teams', { id: team.fullName }) : '#'} alt={teamName}>
      <TeamScoresCol>
        {event.eventStatus > 0 && <div className="score">{score}</div>}
        <img src={getTeamIc(team?.fullName)} alt="Team Logo" />
        <div className="name">{teamName}</div>
        {event.eventStatus < 2 && team?.fullName && (
          <div className="record">{getTeamRecord(team, event.seasonSegment)}</div>
        )}
      </TeamScoresCol>
    </Lk>
  )
}
